module.exports = __webpack_public_path__ + "img/not-found-image.85d4e6ee.png";